import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { DashboardService } from '../../dashboard.service';
import { AdminLanguageService } from '../../services/admin-language-service/admin-language.service';

@Component({
    selector: 'app-edit-control-dialog',
    templateUrl: './edit-control-dialog.component.html',
    styleUrls: ['./edit-control-dialog.component.scss'],
    standalone: false
})
export class EditControlDialogComponent implements OnInit {
  @ViewChild('editForm') editForm:NgForm
  labels;
  labelsSub: Subscription;
  err: boolean = false;
  constructor(public dialogRef: MatDialogRef<EditControlDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private dashboardService:DashboardService, private adminLanguageService: AdminLanguageService,
    public snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.err = false;
    this.getLang()
  }

  onNoClick(){
    this.dialogRef.close()
    this.getLang()
  }

  getLang(){
    this.labelsSub = this.adminLanguageService.labels$.subscribe((labels) => {
      this.labels = labels;
      })
  }

  onSubmit(){
    if(this.editForm.value.textAns1 == "" || this.editForm.value.textAns1 == null){
      this.err = true;
      this.snackBar.open('Morate popuniti sva polja kako biste nastavili.', 'OK', {
        verticalPosition: 'top',
        horizontalPosition: 'end',
        duration: 5000
      })
    }else{
    this.dashboardService.updateTextOfControlAnswer({
      id:this.data.id,
      trainingId: this.data.trainingId,
      sectionId: this.data.sectionId,
      unitId: this.data.unitId,
      questionId: this.data.questionId,
      textAns1:this.editForm.value.textAns1
    }).subscribe((response)=>{
      console.log(response)
      this.snackBar.open(this.labels.lblControlQuestionAnsEdited, 'OK', {
        verticalPosition: 'top',
        horizontalPosition: 'end',
        duration: 5000
      })
      this.dialogRef.close()
    })
   }
  }

}
